import Vue from "vue";
require('./bootstrap');
import BootstrapVue from 'bootstrap-vue'

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

//import VueMask from 'v-mask'

Vue.use(BootstrapVue)
//Vue.use(VueMask);
// import 'node_modules/bootstrap/scss/bootstrap';
// import 'node_modules/bootstrap-vue/src/index.scss';

import VeeValidate from 'vee-validate';


Vue.use(VeeValidate, {
    // This is the default
    inject: true,
    // Important to name this something other than 'fields'
    fieldsBagName: 'veeFields',
    // This is not required but avoids possible naming conflicts
    errorBagName: 'veeErrors',
});

import VueGoogleAutocomplete from 'vue-google-autocomplete'

Vue.use(VueGoogleAutocomplete)


Vue.component('loan-against-share', require('./components/loans/loan-against-share.vue').default);

import { VuejsDatatableFactory } from 'vuejs-datatable';

Vue.use( VuejsDatatableFactory );

Vue.filter('date', function (value) {
  return Date.prototype.toShortFormat
})

Vue.mixin({
    methods: {
        validateState(ref) {
            if (
              this.veeFields[ref] &&
              (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
              return !this.veeErrors.has(ref)
            }
            return null
        },
        removeArrayKey(array, keytoRemove) {
            array = array.map((item, key) => {
              if (key !== keytoRemove) {
                return item
              }
            })

            return array
        },
        getParameterByName(name, url = window.location.href) {
            name = name.replace(/[\[\]]/g, '\\$&');
            var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }
    }
})

var app = new Vue({
    el: '#app',
});
